import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MessageSquare } from "lucide-react";
import { formatTime } from "./utils";
import { AnalyticsEmptyState } from "./AnalyticsStates";

export const AnalyticsCustomerTable = ({ customers }) => {
  if (!customers || customers.length === 0) {
    return <AnalyticsEmptyState type="nodata" />;
  }

  return (
    <Card className="bg-card border-border/50">
      <CardHeader>
        <CardTitle className="text-sm uppercase">
          Clientes Mas Activos en WhatsApp
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {customers.map((customer, idx) => (
            <div
              key={customer.phone}
              className="flex items-center justify-between p-3 rounded-lg hover:bg-secondary/50 transition-colors"
            >
              <div className="flex items-center gap-3 flex-1">
                <span className="text-sm font-bold w-6 text-center text-gray-500">
                  {idx + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate">
                    {customer.name || `+${customer.phone}`}
                  </p>
                  {customer.name && (
                    <p className="text-xs text-gray-500">+{customer.phone}</p>
                  )}
                </div>
              </div>
              <Badge
                variant="secondary"
                className="ml-2 shrink-0 bg-emerald-100 text-emerald-700 border-0"
              >
                <MessageSquare className="w-3 h-3 mr-1" />
                {customer.messages}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
